"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.softwareLicensesRepository = void 0;
exports.licenseRequest = licenseRequest;
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const ToolsFetch_1 = __importDefault(require("../../React/Tools/ToolsFetch"));
const SoftwareLicenseTypes_1 = require("./SoftwareLicenseTypes");
// No retry or diagnostic payload: writes may contain a secret and reveal is audited.
async function licenseRequest(path, method, body, signal) {
    try {
        const response = await fetch(MainSetupReact_1.default.serverUrl + path, {
            method, credentials: "include", cache: "no-store", signal,
            headers: { "Content-Type": "application/json" },
            body: body === undefined ? undefined : JSON.stringify(body),
        });
        if (response.status === 401)
            ToolsFetch_1.default.notifySessionExpired();
        if (!response.ok)
            throw new Error();
        return await response.json();
    }
    catch {
        throw new Error("Nie można wykonać operacji na licencjach. Sprawdź połączenie i uprawnienia. Przed ponowieniem zapisu odśwież listę.");
    }
}
class SoftwareLicensesRepository extends RepositoryReact_1.default {
    async loadItemsFromServerPOST(orConditions = []) {
        const items = await licenseRequest("admin/softwareLicenses", "POST", { orConditions });
        this.items = items.map(SoftwareLicenseTypes_1.publicLicense);
        this.currentItems = [];
        this.saveToSessionStorage();
        return this.items;
    }
    async saveLicense(data, id) {
        const item = (0, SoftwareLicenseTypes_1.publicLicense)(await licenseRequest("admin/softwareLicense" + (id === undefined ? "" : "/" + id), id === undefined ? "POST" : "PUT", data));
        if (id === undefined)
            this.items.push(item);
        else
            this.replaceItemById(id, item);
        this.currentItems = [item];
        this.saveToSessionStorage();
        return item;
    }
}
exports.softwareLicensesRepository = new SoftwareLicensesRepository({
    name: "softwareLicenses",
    actionRoutes: { getRoute: "admin/softwareLicenses", addNewRoute: "admin/softwareLicense",
        editRoute: "admin/softwareLicense", deleteRoute: "admin/softwareLicense" },
});
